export default "__VITE_ASSET__0dc1b4cf__"